import React from 'react';
import { Helmet } from 'react-helmet';

// eslint-disable-next-line react/prop-types
const Header = ({ shopName }) => (
  <div className="u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center">
    <Helmet>
      <title>Receipt | {shopName}</title>
    </Helmet>
    Here is your receipt from {shopName}
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/app/notifications/customer/Receipt/components/Header.jsx